import { MessageSquare } from 'lucide-react';

/**
 * Fixed floating feedback button at bottom right of the page
 * Opens feedback form in a new tab when clicked (shown only in preview mode)
 */
export function FeedbackButton() {
  const handleClick = () => {
    // Open feedback form in new tab
    // For now using a placeholder URL - this should be replaced with actual form URL
    const feedbackUrl = 'https://fs23.formsite.com/TSCINC/vyx166x1sy/index'; // Replace with actual form URL
    window.open(feedbackUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      className="px-4 py-3 rounded-full bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white shadow-lg hover:shadow-xl transition-all focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 flex items-center gap-2"
      aria-label="Give Feedback"
      title="Share your feedback on the new shop experience"
    >
      <MessageSquare className="w-5 h-5" aria-hidden="true" />
      <span className="text-sm font-medium">Share Feedback</span>
    </button>
  );
}
